import { FilterOperator } from './../../../base/models/models.swagger.generated';
import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from '../../../base/services/toast.service';
import {
  ClientClient,
  ClientDTO,
  PagedResultDTOOfClientDTO,
  CreateClientDTO,
  UpdateClientDTO,
  FilterDTO,
  SortDirection
} from '../../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { ClientService } from 'src/app/base/services/client/client.service';

@Injectable()
export class ClientAdministrationService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private clientService: ClientService
  ) {
    super();
   }

  // eslint-disable-next-line max-len
  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfClientDTO> {

    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true'}));
    }

    return this.clientAdministrationClient.searchClients(filters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public updateRecord(data: UpdateClientDTO): Observable<ClientDTO> {
    return this.clientAdministrationClient.updateClient(data)
      .pipe(
        tap((client: ClientDTO) => {
          if (this.clientService.selectedClient && this.clientService.selectedClient.id === client.id) {
            // if client data is the already selected client, we need to update its data as well
            this.clientService.selectedClient = client;
            this.clientService.clients = [client];
          }
          this.toastService.showSuccess(
            'i18n.domain.client-administration.messages.update-title',
            'i18n.domain.client-administration.messages.update-success-message'
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public addRecord(data: CreateClientDTO): Observable<ClientDTO> {
    return this.clientAdministrationClient.createClient(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.client-administration.messages.add-title',
            'i18n.domain.client-administration.messages.add-success-message'
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }

  public deleteRecord(id: number): Observable<any> {
    return this.clientAdministrationClient.deleteClient(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.client-administration.messages.delete-title',
            'i18n.domain.client-administration.messages.delete-success-message'
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        })
      );
  }
}
